<template>
  <div class="button-spinner-wrapper">
    <circle-spinner
      :animation-duration="2000"
      :size="16"
      :color="'rgb(0,100,255)'"
    />
  </div>
</template>

<script setup lang="ts">
import CircleSpinner from '@/components/ui/CircleSpinner.vue'
</script>

<style lang="scss" scoped>
.button-spinner-wrapper {
  position: relative;
  display: inline-flex;
  padding: 0 6px 2px;
}
</style>
